import { checkAutoplay } from 'library/ts/utilities/Autoplay';
import { ConnectionMonitor } from 'library/ts/utilities/network/ConnectionMonitor';
import { executeSmartTagReadyPageCallback } from 'tag/ts/smart_tag/utilities/Callback';
import { TagEvent } from 'tag/ts/tag/events/TagEvent';
export class SmartTagSystemOperations {
    #deps;
    constructor(deps) {
        this.#deps = deps;
    }
    initializeConnectionMonitor = () => {
        if (this.#deps.utilities && this.#deps.capabilities) {
            const monitor = new ConnectionMonitor(this.#deps.utilities, this.#deps.capabilities, this.#connectionManagerCallback.bind(this));
            this.#deps.setConnectionMonitor(monitor);
        }
        else {
            this.#deps.logger.error('Cannot create ConnectionMonitor: utilities or capabilities not available');
        }
    };
    handleAutoplayDetection = () => {
        switch (this.#deps.detectAutoplay) {
            case true:
                this.#runAutoplayDetection();
                break;
            case false:
                this.#executeReadyCallback('checkAutoplay SKIPPED: DETECT_AUTOPLAY=' + this.#deps.detectAutoplay);
                break;
        }
    };
    #runAutoplayDetection() {
        if (this.#deps.capabilities) {
            checkAutoplay(this.#deps.capabilities)
                .then((autoplayInfo) => {
                this.#deps.logger.log('checkAutoplay SUCCESS:', autoplayInfo);
                this.#deps.setAutoplay(autoplayInfo);
                this.#executeReadyCallback();
            })
                .catch((error) => {
                this.#deps.logger.warn('checkAutoplay FAILURE:', error);
            });
        }
        else {
            this.#deps.logger.error('Cannot check autoplay: capabilities not available');
            this.#executeReadyCallback(null, 'no capabilities');
        }
    }
    #executeReadyCallback(logMessage, errorSuffix) {
        setTimeout(() => {
            try {
                if (logMessage) {
                    this.#deps.logger.log(logMessage);
                }
                executeSmartTagReadyPageCallback(this.#deps.smartTagInstance);
            }
            catch (error) {
                const suffix = errorSuffix ? ` (${errorSuffix})` : '';
                this.#deps.logger.error(`Error executing ready callback${suffix}:`, error);
            }
        });
    }
    #connectionManagerCallback = (online) => {
        try {
            const registry = this.#deps.getRegistry();
            if (!registry) {
                this.#deps.logger.warn('connectionManagerCallback:', 'Registry not available');
                return;
            }
            Object.keys(registry).forEach((key) => {
                const tag = registry[key];
                if (!tag?.dispatchTagEvent || !tag?.getTagEventVO) {
                    this.#deps.logger.warn('connectionManagerCallback:', 'Invalid tag structure for key:', key);
                    return;
                }
                try {
                    tag.dispatchTagEvent(tag.getTagEventVO(online === true ? TagEvent.ON_ONLINE : TagEvent.ON_OFFLINE, tag, { online: online }, this.#deps.smartTagInstance, 'SmartTag'));
                }
                catch (eventError) {
                    this.#deps.logger.warn('connectionManagerCallback:', 'Error dispatching event for tag:', key, eventError);
                }
            });
        }
        catch (error) {
            this.#deps.logger.error('connectionManagerCallback:', 'Unexpected error:', error);
        }
    };
}
